<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-email-outline"></i>
        주소검색
    </h4>
</div>

<div class="modal-body">
    <div class="w-100" style="height: 470px;" id="modal-search-addr-content" #modalSearchAddrContent></div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        취소
    </button>
</div>